import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "./redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import { CONFIG } from "./constants";
import { installPreloadReload } from "./utils/helpers";

if (!CONFIG.SENTRY_DSN) {
  // Surface the misconfiguration loudly: an empty DSN makes Sentry.init a
  // silent no-op, so frontend errors stop being reported with no other signal.
  // eslint-disable-next-line no-console
  console.warn(
    "[Sentry] VITE_SENTRY_DSN is not set — frontend error reporting is disabled."
  );
}

Sentry.init({
  dsn: CONFIG.SENTRY_DSN,
  environment: CONFIG.SENTRY_ENVIRONMENT,
  release: CONFIG.SENTRY_RELEASE,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  tracePropagationTargets: [/^https:\/\/app.sudonum.com/],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Reload once when a lazy chunk fails to load. Installed before the first
// render so it is listening before any route's chunk is requested; the lazy
// routes in App.tsx pair with it through lazyWithReload.
installPreloadReload();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter basename={CONFIG.BASE_PATH}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
